export default __webpack_public_path__ + "static/media/protocol.951e64dc.svg";